import * as React from 'react'

import { Wizard, WizardStep } from '@factorialco/deprecated-design-system'

import { EmployeeMeta, LegalEntityMeta, PayrollPolicyMeta } from '../types'
import { addCompensationsStep } from './CompensationsSummaryStep'
import { WizardData } from './state'

const steps = (): WizardStep<WizardData>[] => [addCompensationsStep()]

interface Props {
  targetEmployees: EmployeeMeta[]
  allowedLegalEntities: LegalEntityMeta[]
  allowedPayrollPolicies: PayrollPolicyMeta[]
  onSubmit: (data: WizardData) => void
}

const BulkFixWizard: React.FC<Props> = ({
  targetEmployees: selectedEmployees,
  allowedLegalEntities,
  allowedPayrollPolicies,
  onSubmit,
}) => {
  const initialWizardData: WizardData = {
    targetEmployees: selectedEmployees,
    allowedLegalEntities,
    allowedPayrollPolicies,
    affectedEmployeeIds: new Set(),
    unaffectedEmployeeIds: new Set(selectedEmployees.map((e) => e.id)),
    keepExistingCompensations: true,
    compensations: [],
    multipleLegalEntities: false,
    multiplePayrollPolicies: false,
  }

  return (
    <Wizard.Base
      steps={steps()}
      initialData={initialWizardData}
      onSubmit={onSubmit}
      bottomSpacing={false}
    />
  )
}

export default BulkFixWizard
